import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import Head from "next/head";

export default function BrowserIncompatibilityPage() {
  const { t } = useTranslation(["common", "login"]);
  return (
    <>
      <Head>
        <title>{`myCargill`}</title>
        <meta name="robots" content="noindex, nofollow" />
      </Head>

      {/* TODO: build out this page https://www.mycargill.com/home/en/pages/browserincompatibility */}
      <Box>
        <Container>{t("common:footer.copyright")}</Container>
      </Box>
    </>
  );
}

export const getStaticProps = async ({ locale }: any) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, [
        "login",
        "common",
        "browserincompatibility", // TODO get these strings
      ])),
    },
  };
};
